module.exports = __webpack_public_path__ + "img/asian-fish-1.4019aa9f.jpg";